import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ManagerResponseModel } from 'data/manager/manager.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: ManagerResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<ManagerResponseModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const managerSlice = createSlice({
  name: 'manager',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default managerSlice;
